import React, { Component } from 'react';

import _ from 'i18n';
import { setStep } from "actions";
import {withNavigate} from "../../services/utils";
import Icon, { ICON_MAPPINGS } from '../ui/Icon';

class ThemePreview extends Component {
  constructor(props) {
    super(props);
  }

  closePreview = () => {
    const { previous: { step, url }, navigate } = this.props;
    url && navigate(url);
    this.props.dispatch(setStep(step));
  }

  componentWillUnmount() {
    this.closePreview();
  }

  render() {
    const { content } = this.props;

    return (
      <div>
        <span id="theme-preview_close" className="" onClick={this.closePreview}>
          <Icon name={ICON_MAPPINGS["icon-tt-close"]} size={26} className="icon-tt-close" />
        </span>
        <div id="theme-preview">
          <div className="container-desktop">
            <div className="content" >
              <iframe id="frame" srcDoc={content} />
            </div>
          </div>
          <div className="container-smartphone">
            <div className="content" >
              <iframe id="frame" srcDoc={content} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withNavigate(ThemePreview);
